import React, { PureComponent } from "react";
import "./Forms.css";
import CONSTANTS from "../../constants";
// add .error to component for error state.

class CheckBox extends PureComponent {
  static defaultProps = {
    label: "",
    wrapperClasses: "",
  };
  constructor(props) {
    super(props);
  }

  render() {
    const {
      isChecked,
      label,
      wrapperClasses,
      customLabelStyle,
      ...otherProps
    } = this.props;
    return (
      <div className={`form-wrapper ${wrapperClasses}`}>
        <input
          type="CheckBox"
          {...otherProps}
          defaultChecked={isChecked}
          onClick={(e) => this.props.onClick(e)}
        />
        {label && (
          <label
            style={customLabelStyle}
            htmlFor={this.props.id}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
      </div>
    );
  }
}
export default CheckBox;
